import { inject, injectable } from 'inversify';
import { Match } from '@Models';
import { tool_pairing_match } from '@Api';
import { TYPES } from '@Types';
import { TeamArmyMapper } from './TeamArmyMapper';

@injectable()
export class MatchMapper {
  @inject(TYPES.Mapper.TeamArmyMapper) private _teamArmyMapper!: TeamArmyMapper;

  public map(item: tool_pairing_match): Match {
    return {
      id: item.id,
      round: item.round,
      opponentTeamArmy: this._teamArmyMapper.map(item.opponent_team_army),
      opponentTeamArmyId: item.opponent_team_army_id,
      myTeamArmy: this._teamArmyMapper.map(item.my_team_army),
      myTeamArmyId: item.my_team_army_id,
    } satisfies Match as Match;
  }
}
